import { Routes } from '@angular/router';

const title = 'Mascotas admisión';
const data = { title, isShowBreadcrumb: true };

export const ROUTES: Routes = [
  {
    path: 'mascota-pendiente',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Pendientes' }] },
        loadComponent: () => import('./pages/mascota-pendiente-lista/mascota-pendiente-lista.component'),
      },
    
    ],
  },

   {
    path: 'mascota-aprobado',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Aprobados' }] },
        loadComponent: () => import('./pages/mascota-aprobada-lista/mascota-aprobada-lista.component'),
      },
    
    ],
  },

  {
    path: 'mascota-rechazado',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Observados y rechazados' }] },
        loadComponent: () => import('./pages/mascota-rechazada-lista/mascota-rechazada-lista.component'),
      },
    ],
  },

  {
    path: 'mascota-observado-rechazado',
    children: [
      {
        path: '',
        title,
        data: { ...data, urls: [{ title: 'Observados y rechazados' }] },
        loadComponent: () => import('./pages/mascota-rechazada-lista/mascota-rechazada-lista.component'),
      },
    ],
  },
];
